import { render } from "./PlatformsCard.vue?vue&type=template&id=1f4b700c&scoped=true"
import script from "./PlatformsCard.vue?vue&type=script&lang=js"
export * from "./PlatformsCard.vue?vue&type=script&lang=js"

import "./PlatformsCard.vue?vue&type=style&index=0&id=1f4b700c&scoped=true&lang=css"

import exportComponent from "C:\\Git_repos\\MovieVote\\movievote-client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f4b700c"]])

export default __exports__